<template>
  <IQOS 
    :warning="shouldBeShown ? $t('demo_qrcode.title') : null"
    :title="shouldBeShown ? null : $t('demo_qrcode.title_normal')"
    >
      <div class="demo-qr-container">
          <img :src="demoLink" class="iqos-qrcode-image"/>
          <div class="demo-text">
              <p class="comment c-gray pt-0">
                  {{ $t('demo_qrcode.text') }}
              </p>
          </div>
      </div>
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue"
import QRCode from "@/components/QRCode.vue"

export default {
    components: {
        IQOS,
        QRCode
    },
    props: {
        mode: String,
    },
    methods: {

    },
    computed: {
        demoLink() {
            let final_link = 'https://app.qrwaiter.com.ua';

            if (this.mode == 'inside' || this.mode == 'rooms') {
                const first_table = btoa(`${this.$store.state.cafe._id}/0/1`); 

                const mode_route = this.mode == 'rooms' ? 'room' : 'new';

                final_link = `https://app.qrwaiter.com.ua/${mode_route}/${first_table}`;
            } else {
                final_link = this.$store.getters.onlineMenuLink();
            }

            return `https://api.qrserver.com/v1/create-qr-code/?size=128x128&data=${final_link}`
        },
        shouldBeShown() {
            return this.$store.getters['subscriptions/isDemoPeriod'](this.mode);
        }
    }
}
</script>

<style scoped>
.demo-qr-container {
    display: flex;
    align-items: center;
}

.demo-text {
    margin-left: 5.3vh;
}
</style>